(() => {
  const form = document.getElementById('AddToCartForm');
  if (!form) return;

  const labelImageOptions = () => {
    for (const label of form.querySelectorAll('label.ymq-option-label')) {
      const input = label.querySelector('input.ymq-option-swatches-input');
      if (!input || !label.querySelector('img') || input.hasAttribute('aria-label') || input.hasAttribute('aria-labelledby')) continue;
      const name = input.value.trim();
      if (name) input.setAttribute('aria-label', name);
    }
  };

  labelImageOptions();
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      labelImageOptions();
    });
  });
  observer.observe(form, { childList: true, subtree: true });
})();

